/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Value_NoneInputs */

const en_us2_search_value_none = /** @type {(inputs: Search_Value_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No answer`)
};

const pt_br2_search_value_none = /** @type {(inputs: Search_Value_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sem resposta`)
};

const es_419_search_value_none = /** @type {(inputs: Search_Value_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sin respuesta`)
};

const pt_pt2_search_value_none = /** @type {(inputs: Search_Value_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sem resposta`)
};

const fr_fr2_search_value_none = /** @type {(inputs: Search_Value_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pas de réponse`)
};

const de_de2_search_value_none = /** @type {(inputs: Search_Value_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Antwort`)
};

const it_it2_search_value_none = /** @type {(inputs: Search_Value_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessuna risposta`)
};

/**
* | output |
* | --- |
* | "No answer" |
*
* @param {Search_Value_NoneInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_value_none = /** @type {((inputs?: Search_Value_NoneInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Value_NoneInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_value_none(inputs)
	if (locale === "es-419") return es_419_search_value_none(inputs)
	if (locale === "pt-PT") return pt_pt2_search_value_none(inputs)
	if (locale === "fr-FR") return fr_fr2_search_value_none(inputs)
	if (locale === "de-DE") return de_de2_search_value_none(inputs)
	if (locale === "it-IT") return it_it2_search_value_none(inputs)
	return en_us2_search_value_none(inputs)
});
export { search_value_none as "search.value_none" }